export default "__VITE_ASSET__c1cc5561__"